import { Box, BoxProps } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

import { Link } from "../Link/Link";

export interface SelectableProps extends BoxProps {
  isSelected?: boolean;
  isFocused?: boolean;
  href?: string;
}

export const classes = {
  root: "Selectable-root",
};

const getDefaultOutline = (
  isSelected: boolean,
  isFocused: boolean,
  theme: Theme,
) => {
  if (isSelected) return `3px solid ${theme.palette.primary.light}`;
  if (isFocused) return `3px solid ${theme.palette.secondary[4]}`;
  return "3px solid transparent";
};

const Root = styled(Box, {
  shouldForwardProp: (prop) =>
    typeof prop !== "string" || !["isSelected", "isFocused"].includes(prop),
})<{ isSelected?: boolean; isFocused?: boolean }>(
  ({ theme, isSelected = false, isFocused = false }) => ({
    transition: "all 0.1s ease-in-out",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    overflow: "hidden",
    cursor: "pointer",
    outline: getDefaultOutline(isSelected, isFocused, theme),
    "&:hover, &:focus-within": {
      outline: isSelected
        ? `3px solid ${theme.palette.primary.light}`
        : `3px solid ${theme.palette.secondary[4]}`,
    },
  }),
);

export const Selectable = (props: SelectableProps) => {
  const { isSelected, isFocused, href, className = "", ...rest } = props;

  return (
    <Root
      data-testid="selectable"
      className={`${classes.root} ${className}`}
      isSelected={isSelected}
      isFocused={isFocused}
      {...(href
        ? { component: Link, href }
        : {
            "aria-selected": isSelected,
            tabIndex: 0,
          })}
      {...rest}
    />
  );
};
